import Backdrop from '@mui/material/Backdrop';

import { Box, styled } from '@encapital/ui';

export const StyledBackdrop = styled(Backdrop)`
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  transition: none !important;
`;

export const StyledWrapModal = styled(Box)`
  display: flex;
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border-radius: 8px;
  border: 1px solid var(--light-line, rgba(0, 0, 0, 0.05));
  background: #fff;
  padding: 24px;
  font-family: Be Vietnam Pro, ui-sans-serif, system-ui, -apple-system,
    BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans,
    sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol,
    Noto Color Emoji;
  color: #333333;
`;
